module.exports = __webpack_public_path__ + "img/ev_station_outlined.bb431483.svg";